import { Skeleton } from 'antd';
import React from 'react';
import { Colors, FontSize, FontWeight, LineHeight } from '@common/tokens';

type Props = {
  title?: string;
  subtitle?: string;
  url?: string;
  placeholder?: boolean;
};

export function QuickArticlesCard({
  title,
  subtitle,
  url,
  placeholder,
}: Props) {
  return (
    <div className="quick-articles-card">
      {placeholder ? (
        <Skeleton active title={false} />
      ) : (
        <a href={url} target="_blank" rel="noreferrer">
          <label>{title}</label>
          <p>{subtitle}</p>
        </a>
      )}
      <style jsx>{`
        .quick-articles-card {
          border: 1px solid ${Colors.steel};
          padding: 12px 16px;
          border-radius: 8px;
          height: 100%;
          overflow: hidden;
          transition: border 0.2s linear;
        }

        .quick-articles-card:hover {
          border: 1px solid ${Colors.elm};
        }

        .quick-articles-card a {
          cursor: pointer;
        }

        .quick-articles-card label {
          font-size: ${FontSize.md};
          font-weight: ${FontWeight.medium};
          line-height: ${LineHeight.md};
          display: block;
          cursor: pointer;
          color: ${Colors.textDefault};
          margin-bottom: 4px;
        }

        .quick-articles-card p {
          margin: 0;
          font-weight: 400;
          line-height: ${LineHeight.md};
          font-style: normal;
          color: ${Colors.steelDarkest};
        }
      `}</style>
    </div>
  );
}
